import { Mail, MapPin, Youtube, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { useLocalizedPath } from "@/hooks/useLocalizedNavigate";

const Footer = () => {
  const { t, locale } = useLanguage();
  const lp = useLocalizedPath();

  return (
    <footer className="border-t border-border/60 bg-card">
      <div className="container py-10 md:py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              <Link to={lp("/")} className="hover:text-primary transition-colors" aria-label="Hirafi — Accueil">{locale === "ar" ? "حرفي" : "Hirafi"}</Link>
            </h4>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Plateforme */}
          <div>
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">{t("footer.platform")}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to={lp("/annonces")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.annonces")}</Link></li>
              <li><Link to={lp("/poster-annonce")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.poster")}</Link></li>
              <li><Link to={lp("/inscription")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.devenir_artisan")}</Link></li>
            </ul>
          </div>

          {/* Informations */}
          <div>
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">{t("footer.information")}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to={lp("/a-propos")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.about")}</Link></li>
              <li><Link to={lp("/aide")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.aide")}</Link></li>
              <li><Link to={lp("/cgu")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.cgu")}</Link></li>
              <li><Link to={lp("/confidentialite")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.confidentialite")}</Link></li>
              <li><Link to={lp("/mentions-legales")} className="text-muted-foreground hover:text-primary transition-colors">{t("footer.legal")}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">{t("footer.contact")}</h4>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li>
                <a
                  href="mailto:contact@hirafidz.com"
                  className="inline-flex items-center gap-1.5 hover:text-primary transition-colors"
                >
                  <Mail className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                  contact@hirafidz.com
                </a>
              </li>
              <li className="flex items-center gap-1.5">
                <MapPin className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                {t("footer.location")}
              </li>
              <li className="flex items-center gap-2 pt-2">
                <a
                  href="https://www.youtube.com/@hirafiapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Hirafi sur YouTube"
                  className="group flex h-9 w-9 items-center justify-center rounded-full border border-border/60 bg-muted/30 text-muted-foreground transition-all duration-200 hover:border-transparent hover:bg-foreground hover:text-background hover:scale-105"
                >
                  <Youtube className="h-4 w-4" aria-hidden="true" />
                </a>
                <a
                  href="https://www.linkedin.com/company/hirafidz/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Hirafi sur LinkedIn"
                  className="group flex h-9 w-9 items-center justify-center rounded-full border border-border/60 bg-muted/30 text-muted-foreground transition-all duration-200 hover:border-transparent hover:bg-foreground hover:text-background hover:scale-105"
                >
                  <Linkedin className="h-4 w-4" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border/60 pt-6 flex flex-col items-center gap-2 text-xs text-muted-foreground">
          <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
            <Link to={lp("/cgu")} className="hover:text-primary transition-colors">{t("footer.cgu")}</Link>
            <Link to={lp("/confidentialite")} className="hover:text-primary transition-colors">{t("footer.confidentialite")}</Link>
            <Link to={lp("/mentions-legales")} className="hover:text-primary transition-colors">{t("footer.legal")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
